import React from "react";
import { FaGraduationCap, FaMoneyBillWave, FaUserTie } from "react-icons/fa";

const services = [
  {
    id: 1,
    title: "Hire Credit Specialist",
    description: "Done for You: Credit Repair & Funding Specialist",
    price: "$199",
    icon: <FaUserTie className="icons" />,
  },
  {
    id: 2,
    title: "Invest Portal",
    description: "Access Resources for Investing your Funding Successfully",
    price: "$99",
    icon: <FaGraduationCap className="icons" />,
  },
  {
    id: 3,
    title: "Funding Portal",
    description: "Access Resources for Maximum Personal & Business Funding",
    price: "$29",
    icon: <FaMoneyBillWave className="icons" />,
  },
];

const AddOns = () => {
  return (
    <div className="container addons">
      <div className="row">
        {services.map((service) => (
          <div className="col-md-4" key={service.id}>
            <div className="card">
              <div className="card-body p-0">
                <div className="addons_icons">{service.icon}</div>
                <h3 className="mt-3">{service.title}</h3>
                <p className="mt-2">{service.description}</p>
                <button className="btn mt-3">Pay Now: {service.price}</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AddOns;
